


  
  

  var faCablefilling = {
    prefix: 'fak',
    iconName: 'cablefilling',
    icon: [
      640,
      512,
      [],
      'e01c',
      
      'M534.1 484.5H105.9c-18.2 0-33.3-15-33.3-33.3V61.1c0-6.1-5.1-11.2-11.2-11.2H-1.9V27.8h63.4c18.2 0 33.3 15 33.3 33.3v390.1c0 6.1 5.1 11.2 11.2 11.2h428.2c6.1 0 11.2-5.1 11.2-11.2V61.1c0-18.2 15-33.3 33.3-33.3h63.4v22.1h-63.4c-6.1 0-11.2 5.1-11.2 11.2v390.1c0 18.2-15 33.3-33.3 33.3zm-121-34.2c-65 0-117.8-52.8-117.8-117.8s52.8-117.8 117.8-117.8 117.8 52.8 117.8 117.8-52.8 117.8-117.8 117.8zm0-213.4c-52.8 0-95.7 42.9-95.7 95.7s42.9 95.7 95.7 95.7 95.7-42.9 95.7-95.7-42.9-95.7-95.7-95.7zM191.4 450.2c-43.2 0-78.4-35.2-78.4-78.4s35.2-78.4 78.4-78.4 78.4 35.2 78.4 78.4-35.2 78.4-78.4 78.4zm0-134.4c-31 0-56 25.3-56 56s25.3 56 56 56 56-25.3 56-56-25.3-56-56-56z'
      
    ]
  };

  

  
  

  var faConnector = {
    prefix: 'fak',
    iconName: 'connector',
    icon: [
      640,
      512,
      [],
      'e014',
      
      'M609.6 57l-56-32.6-2.9-1.6-3.2-.6s-8.6-1.9-18.2-1.9c-14.1 0-26.2 3.5-35.8 10.2c-9.6 7-21.4 20.5-21.8 45.8l-13.1 176.3-25.9-25.9-6.4-6.4H285.1l-6.4 6.4-33 33H121.6l-6.4 6.4-16.3 16.3H39.7s-21.4 .3-21.4 .3v75.5H265v133.8h178.2V355.2h29.1s1.3 0 2.2 0c6.1 0 18.2-1.3 29.8-8.6c10.2-6.7 22.4-20.5 22.4-47c0-35.8 9-153.3 12.5-199.4l48 25.3 30.4 16 1.3-34.6 1-31V63s-10.6-6.4-10.6-6.4h0zm-11.8 49.6l-50.6-26.9c-5.4-2.6-10.2-3.2-14.4-3.2c-8 0-13.1 3.2-13.1 3.2s-14.1 174.1-14.1 219.8c0 32.3-24 34.2-30.4 34.2c-1 0-1.6 0-1.6 0h-51.2s0 136.6 0 136.6H287V336.6H40.6V304h67.8s22.7-23 22.7-23h124.2l39.4-39.4h123.2l40 40s1.9 1.6 2.9 1.9c1 .6 4.2 1.3 4.2 1.3c12.8 0 13.8-8.3 13.8-8.3l14.7-199.7c0-30.4 21.4-35.5 36.2-35.5c7.4 0 13.1 1.3 13.1 1.3l56 32.6-1 31h0z'
      
    ]
  };

  

  
  

  var faGirderSection = {
    prefix: 'fak',
    iconName: 'girder-section',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M132.5 26.9l143.7 1.6v45.8h-65.9v50.9l68.5 68.5h94.1l68.5-68.5V74.2h-65.9V28.5h132.5v457.3H375.4V440h60.8v-45.8l-60.8-60.8h-99.2l-60.8 60.8V440h60.8v45.8H132.5V26.9M105.9 0v512h196.5v-98.6h-60.8v-8.3l45.4-45.4h77.1l45.4 45.4v8.3h-60.8V512h185.3V2.2H348.8v98.6h65.9v13.4l-53.1 53.1h-72l-53.1-53.1v-13.4h65.9V2.6h-25.9S132.8 .3 132.8 .3h-26.6s0 0 0 0z'
      
    ]
  };

  

  
  

  var faGrounding = {
    prefix: 'fak',
    iconName: 'grounding',
    icon: [
      512,
      512,
      [],
      'e00c',
      
      'M362.7 512H149.3c-12.8 0-21.3-8.5-21.3-21.3s8.5-21.3 21.3-21.3h211.2c12.8 0 21.3 8.5 21.3 21.3s-8.5 21.3-21.3 21.3zm68.3-93.9H81.1c-12.8 0-21.3-8.5-21.3-21.3s8.5-21.3 21.3-21.3h352c12.8 0 21.3 8.5 21.3 21.3s-8.5 21.3-21.3 21.3zm59.7-115.2H21.3C8.5 302.9 0 294.4 0 281.6s8.5-21.3 21.3-21.3h213.3V21.3C234.7 8.5 243.2 0 256 0s21.3 8.5 21.3 21.3v238.9h213.3c12.8 0 21.3 8.5 21.3 21.3s-8.5 21.3-21.3 21.3z'
      
    ]
  };

  

  
  

  var faGroundingClamp = {
    prefix: 'fak',
    iconName: 'grounding-clamp',
    icon: [
      640,
      512,
      [],
      'e013',
      
      'M515.5 499.5H162.2v-57.6H46.7C27.8 441 0 426.6 0 391.4V283.2h84.5v64.3H104l34.6-57.3c5.4-11.2 20.5-29.1 44.2-29.1h30.7l1.6-106.6 24-18.6h28.5l1-136h142.1v137H439l17.6 17.6v89.6c0 2.6 0 9.3 0 17h37.1c1.9 0 18.9 2.6 36.2 16c14.4 10.9 31 31.7 34.2 68.5h69.8v97.9H515.5v55.7h0zM189.4 472.6h299.2V417H607v-43.8h-69.4v-13.4c0-27.8-8.3-48.3-24.3-60.8c-9.9-7.7-19.8-9.9-22.4-10.2h-61.4v-13.1c-.6-21.4-.6-29.1-.6-32.3h0v-76.8l-1.9-1.9h-44.2V27.2h-88l-1 136h-46.1l-6.4 5.1-1.9 120h-57.3c-12.8 0-19.5 13.8-19.8 14.1v.6s-.6 .6-.6 .6l-42.9 70.7H57v-64.3H26.6v81.3c0 20.2 15.4 23.4 20.8 23.7h141.4v57.6h0z'
      
    ]
  };

  

  
  

  var faLongStrut = {
    prefix: 'fak',
    iconName: 'long-strut',
    icon: [
      640,
      512,
      [],
      'e011',
      
      'M223 0v512h194.2V0H223zm26.2 26.6h141.4V39l-74.6 21.8h-66.6V26.6h0zm-1 426.2h22.4l2.2 2.2v31.4h-24.6v-33.6zm143.4 33.6h-26.6V456l3.2-3.2h23.4v33.6zm0-58.9h-33.6l-18.2 17.9v41h-41.3v-42.2l-17.3-17h-32.6V86.4H320l72-21.1v362.2h0z'
      
    ]
  };

  

  
  

  var faOvervoltage = {
    prefix: 'fak',
    iconName: 'overvoltage',
    icon: [
      640,
      512,
      [],
      'e01d',
      
      'M332.5 34.9c-8-3.5-17.3-3.5-25.3 0l-178.6 75.8c-11.5 4.8-19.2 15.7-18.9 27.8c.6 95 39.7 262.7 197.4 338.2c8 3.8 17.3 3.8 25.3 0c157.8-75.5 197.1-242.9 197.8-338.2c0-12.2-7.7-23-18.9-27.8L332.8 34.9h0zM294.7 5.1c16.3-6.7 34.2-6.7 50.6 0L523.8 81c22.1 9.3 38.7 31.4 38.7 57.9c-.6 100.2-41.6 283.8-216 367c-17 8-36.5 8-53.4 0C119 422.4 77.8 239 77.4 138.9c0-26.6 16.3-48.3 38.7-57.9L294.7 5.1zm73.6 105.3c2.6-2.2 6.1-3.5 9.6-3.5c9.9 0 17 9.9 13.8 19.5L352 237.8h64.3c8.6 0 15.7 7 15.7 15.7c0 4.5-1.9 9-5.4 11.8L271.4 401.9c-2.6 2.2-6.1 3.5-9.6 3.5c-9.9 0-17-9.9-13.8-19.5l39.7-111.4h-65c-8.3 0-15-6.7-15-15c0-4.2 1.9-8.3 5.1-11.2L368 110.4zm.3 24.6l-136 121h68.8c2.9 0 5.8 1.6 7.7 3.8s2.2 5.8 1.3 8.6L271.7 377 409 256h-69.8c-2.9 0-5.8-1.6-7.7-3.8s-2.2-5.8-1.3-8.6L369 135h0z'
      
    ]
  };

  

  
  

  var faRoof = {
    prefix: 'fak',
    iconName: 'roof',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M529 121.6V88.3L430.4 6.1c-9.6-8.3-23.4-8.3-33 0L298.9 88V51.2H196.5v122.2l-75.8 63c-8.6 6.7-11.5 18.2-7.7 28.5c1.3 3.8 3.8 7.4 6.7 9.6V512h25.6V281.6h384.3V256h-393L413.4 25.6l115.5 96zM273 103.7l-51.2 44.8V76.8H273v26.9z'
      
    ]
  };

  

  
  

  var faRoofHook = {
    prefix: 'fak',
    iconName: 'roof-hook',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M453.4 401h0S124.2 292.2 124.2 292.2c-1.6-.6-2.9-2.2-2.9-4.2V127.4c0-9.9 8.3-18.2 18.2-18.2h291.8S431.4 0 431.4 0h-25.3v83.5l-75.8-.6V36.8H305v46.7H139.5C115.5 83.5 96 103 96 127v160.6c0 12.8 8.3 24 20.5 28.2l286.7 94.7v101.1h141.1v-81.9L453.8 401h0zm65.3 85.4h-90.2v-67.2l90.2 28.8v38.4z'
      
    ]
  };

  

  
  

  var faShortStrut = {
    prefix: 'fak',
    iconName: 'short-strut',
    icon: [
      640,
      512,
      [],
      'e016',
      
      'M533.8 66.9l-.6-3.2c-1.9-10.6-6.4-25.6-17.3-37.1c-10.2-10.6-24.3-16.3-40.6-16.3s-31 5.8-41.3 16.3c-8 9-13.8 20.5-16.3 34.9l-.6 3.2h-3.5L19.8 67.2v433.3h120.3l28.2-28.5v-25.6H473v26.9l28.2 28.5h119V66.9h-86.4zM137.6 459.5l-10.2 10.2H50.6V304.3h76.2l10.9 10.6v144.6zM589.4 471h-75.5l-10.2-10.2v-145l10.9-10.2h74.9V471zm0-196.2h-87.4L473 303v112.6H168.3V301.8l-29.1-28.2H50.6V97.6h4.2L447 95V79s-1-20.5 9.3-31.4c4.5-4.5 10.6-6.7 18.9-6.7c10.2 0 15 3.5 18.2 6.7c9.3 9.3 10.6 27.5 10.6 33.9l-1 16h86.4v177.3z'
      
    ]
  };

  

  
  

  var faSubstructure = {
    prefix: 'fak',
    iconName: 'substructure',
    icon: [
      640,
      512,
      [],
      'e017',
      
      'M624 223.4V25.3H16v198.4h84.2v65H16V487h608V288.6h-89.6v-65H624zM100.2 459.5H42.9v-144h57.3v144zm496.6-407v144h-62.4V52.5h62.4zM127 52.5h60.2v144H127V52.5zm-26.9 144H42.9V52.5h57.3v144zm87 263H127v-144h60.2v144zm320 0h-54.4v-144h54.4v144zm0-170.9h-81.6v171.2H214.1V288.6h-87v-65h87V52.5h211.5v171.2h81.6v65zm0-92.2h-54.4V52.5h54.4v144zm89.6 119v144h-62.4v-144h62.4z'
      
    ]
  };

  

  
  

  var faUnderfloor = {
    prefix: 'fak',
    iconName: 'underfloor',
    icon: [
      512,
      512,
      [],
      'e00b',
      
      'M277.3 507.7c-2.1 0-4.3 0-6.4 0L14.9 375.5c-4.3-2.1-8.5-8.5-8.5-12.8c0-6.4 0-10.7 6.4-14.9l204.8-145.1L160 25.6c0-6.4 0-12.8 4.3-17.1s10.7-6.4 17.1-2.1l264.5 106.7c4.3 0 8.5 6.4 8.5 10.7L512 330.7h0s-2.1 2.1-2.1 2.1l-115.2 89.6-10.7-12.8 10.7 12.8-106.7 81.1c-2.1 2.1-6.4 4.3-10.7 4.3zm-121.6-96l119.5 59.7 78.9-59.7-115.2-55.5-81.1 55.5zm-32 2.1h0c0 2.1 0 0 0 0zM51.2 358.4l70.4 36.3 98.1-66.1v-89.6L53.3 358.4zm200.5-29.9l130.1 61.9 76.8-59.7-206.9-96v93.9zm-2.1-130.1l221.9 102.4-44.8-160L200.5 49.1l49.1 149.3z'
      
    ]
  };

  

  
  

  var faUniBase = {
    prefix: 'fak',
    iconName: 'uni-base',
    icon: [
      640,
      512,
      [],
      'e00f',
      
      'M530.6 192.6l-64.3-102.4-53.8 40-160-76.8-61.8 95L0 252.2l320 206.4 320-203.2-109.4-62.7h0zM393 144l-66.9 47.4-73.6-37.4 68.8-44.2 72 34.6h0zM260.2 80.6l37.4 17.9-80.3 48 42.9-65.9h0zM41.6 253.8l105.9-57.6-37.4 101.4-68.2-44.2h0zM320.3 433.3l-192-123.5 40.3-109.1 58.9-35.2 159.4 81 45.8 115.2-112.6 71.4h0zM403.8 231l-56.6-28.8 67.5-47.7 5.1-3.5 40.6-30.1 54.7 87.7 83.5 48-147.8 93.8-47.4-119h0z'
      
    ]
  };

  

  
  

  var faUniversalClamp = {
    prefix: 'fak',
    iconName: 'universal-clamp',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M523.5 142.1v-41s-14.1 2.2-14.1 2.2c-6.4 1-21.1 1.3-27.2-3.8c-1.3-1-2.6-2.9-2.6-6.7c0-16-6.4-25-11.8-29.8c-10.2-9.3-23.4-9-27.2-8.6h-57.3V0H256v54.1h-57.3c-3.8 0-17-.6-27.2 8.6c-5.4 4.8-11.8 13.8-11.8 29.8c0 4.2-1.3 5.8-2.6 6.7c-6.1 5.1-20.8 4.8-26.9 3.8l-14.1-2.2v41h109.8l-1.3 287.7v2.6l35.5 79.4h119l35.5-79.4-1.3-290.2h109.8 0zM363.8 487.7h-87.7l-26.9-60.5 1.3-309.4h-77.4s0 0 0 0c7.4-6.1 11.2-15 11.2-25.3c0-5.4 1.3-9.6 3.5-11.5c2.9-2.6 7-2.9 8.6-2.9c.3 0 .6 0 .6 0h.6s82.9 0 82.9 0V24.3h79v54.1h83.5s5.8-.3 9.3 2.6c2.6 2.2 3.5 6.1 3.5 11.8c0 10.2 3.8 18.9 11.2 25.3c0 0 0 0 0 0h-77.4l1.3 309.4-26.9 60.5h0z'
      
    ]
  };

  



export {

  faCablefilling,
  

  faConnector,
  

  faGirderSection,
  

  faGrounding,
  

  faGroundingClamp,
  

  faLongStrut,
  

  faOvervoltage,
  

  faRoof,
  

  faRoofHook,
  

  faShortStrut,
  

  faSubstructure,
  

  faUnderfloor,
  

  faUniBase,
  

  faUniversalClamp,
  

};
